/* eslint-disable max-len */
import { SvgIcon, SvgIconProps } from '@mui/material';

export default function TableViewIcon(props: SvgIconProps) {
  return (
    <SvgIcon xmlns="http://www.w3.org/2000/svg" width="24" height="22" viewBox="0 0 24 22" {...props}>
      <path d="M24 5.33333H0V0H24V5.33333ZM24 8H0V13.3333H24V8ZM24 16H0V21.3333H24V16Z" fill="currentColor"/>
    </SvgIcon>
  );
}

